import { getMpcpMaxCoverage } from "@estaly/ui";

const ELECTRONIC_DEVICES_VALUE_TO_MAX_COVERAGE_AMOUNT = {
  less_than_500: 500, // BRONZE
  five_hundred_to_one_thousand: 1000, // ARGENT
  one_thousand_to_three_thousand: 3000, // OR
  three_thousand_to_five_thousand: 5000, // PLATINE
};

/**
 * Retourne l'offre recommandée parmi la liste, selon advisoryAnswer et productPrice, ou null.
 * @param {Array} offers - Liste d'offres (lead.offers ou contracts)
 * @param {Object} context - { advisoryAnswer, productPrice }
 * @returns {Object|null} L'offre recommandée (même référence que dans offers) ou null
 */
export function getRecommendedOffer(offers, context) {
  if (!Array.isArray(offers) || offers.length === 0) return null;

  const { advisoryAnswer = {}, productPrice } = context;
  const offerType = advisoryAnswer.offerType;

  if (offerType === "connect_protection") {
    const electronicDevicesValue = advisoryAnswer.electronicDevicesValue;
    const recommendedMaxCoverage = ELECTRONIC_DEVICES_VALUE_TO_MAX_COVERAGE_AMOUNT[electronicDevicesValue];
    if (recommendedMaxCoverage == null) return null;
    return offers.find((o) => getMpcpMaxCoverage(o?.offerMarketingTitle) === recommendedMaxCoverage) ?? null;
  }

  if (offerType === "mobile_protection") {
    const price = parseFloat(productPrice);
    if (!Number.isFinite(price)) return null;
    const covering = offers.filter((o) => {
      const maxCoverage = getMpcpMaxCoverage(o?.offerMarketingTitle);
      return maxCoverage != null && maxCoverage >= price;
    });
    if (covering.length === 0) return null;
    return covering.reduce((closest, o) => {
      const maxCoverage = getMpcpMaxCoverage(o?.offerMarketingTitle);
      const closestCoverage = getMpcpMaxCoverage(closest?.offerMarketingTitle);
      return maxCoverage < closestCoverage ? o : closest;
    });
  }

  return null;
}
